
import { ITongHopThongKeActionTypes } from "../../action-types/tong-hop-thong-ke/ITongHopThongKeActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { ITongHopThongKeReducer } from "../../reducer-model/tong-hop-thong-ke/ITongHopThongKeReducer";

const iniState: ITongHopThongKeReducer = {
    status: eReducerStatusBase.is_not_initialization,
    selectedMenu: "",
};

export const tongHopThongKeReducer = (state = iniState, action: ITongHopThongKeActionTypes): ITongHopThongKeReducer => {
    switch (action.type) {
        case "TONG_HOP_THONG_KE_SELECTED_MENU":
            return {
                ...state,
                selectedMenu: action.payload,
                status: eReducerStatusBase.is_completed
            };
        default:
            return state;
    }
};